import * as React from "react";
import { useTranslation } from "react-i18next";
import { CheckOutState } from "functions/src/shared/Digital/User/PaymentInfo";
export default function CheckOutErrorMessage({
  currentTrade,
}: {
  currentTrade: CheckOutState;
}) {
  const { t } = useTranslation("checkout");
  const [errorMessage, setErrorMessage] = React.useState("");
  React.useEffect(() => {
    switch (currentTrade.reason_code) {
      case "102":
        setErrorMessage(t("error-invalid-fields"));
        break;
      case "150":
        setErrorMessage(t("error-try-again"));
        break;
      case "204":
        setErrorMessage(t("error-contact-issuing-bank"));
        break;
      case "476":
        setErrorMessage(t("reason-code-476-message"));
        // setErrorMessage(
        //   "Encountered a Payer Authentication problem. Payer could not be authenticated. Please contact the issuing bank. (Enable the pop-up screen to validate the Payer Authentication process. We have received some payment failure reports due to these reasons.)"
        // );
        break;
      case "101":
        setErrorMessage("Declined - The request is missing one or more fields");
        break;
      case "102":
        setErrorMessage(
          "Declined - One or more fields in the request contains invalid data."
        );
        break;
      case "150":
        setErrorMessage("Error - General system failure.");
        break;
      case "151":
        setErrorMessage(
          "Error - The request was received but there was a server timeout. This error does not include timeouts between the client and the server."
        );
        break;
      case "152":
        setErrorMessage(
          "Error: The request was received, but a service did not finish running in time."
        );
        break;
      case "475":
        setErrorMessage(t("reason-code-475-message"));
        // setErrorMessage(
        //   "The cardholder is enrolled in Payer Authentication. Please authenticate the cardholder before continuing with the transaction. Please contact the issuing bank."
        // );
        break;
      case "203":
        setErrorMessage(t("reason-code-203-message"));
        // setErrorMessage(
        //   "Decline - General decline of the card. No other information provided by the issuing bank. Please contact the issuing bank."
        // );
        break;
      case "211":
        // setErrorMessage("Decline - Invalid Card Verification Number (CVN).");

        setErrorMessage(t("reason-code-211-message"));
        break;
      case "200":
        setErrorMessage(t("reason-code-200-message"));
        // setErrorMessage(
        //   "Soft Decline - The authorization request was approved by the issuing bank but flagged by CyberSource because it did not pass the Address Verification Service (AVS) check."
        // );
        break;
      default:
        setErrorMessage(t("error-try-again"));
        break;
    }
  });
  return <React.Fragment>{errorMessage}</React.Fragment>;
}
